export default {"src":"/_next/static/media/COINDESK_LOGO.a34c4503.svg","height":16,"width":78,"blurWidth":0,"blurHeight":0};